/* Hubs Hero */
import 'slick-carousel';
import 'select2';
// import Datepicker from 'vanillajs-datepicker/Datepicker';

export function hubs_hero() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.block--hubs-hero' ).length <= 0 /* && $( '.block--hubs-hero--gallery .slick-slide' ).length > 1 */ ) {
				return;
			}

			$( '.block--hubs-hero--gallery' ).each( ( i, e ) => {
				const slider = $( e );

				slider.slick( {
					arrows: false,
					autoplay: true,
					autoplaySpeed: 3000,
					dots: false,
					fade: true,
					infinite: true,
					pauseOnFocus: false,
					pauseOnHover: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					swipe: false,
					rows: 0
				} );
			} );

			// Select2 for RV
			if ( $( '.block--hubs-hero--widget--rv' ).length > 0 ) {
				const selector = $( '.block--hubs-hero--widget--rv' ).find( '#rv-destination' );
				const datefield = $( '.block--hubs-hero--widget--rv' ).find( '#rv-arrival-date' );

				selector.select2({
					allowClear: true,
					width: '100%',
					dropdownParent: $( '#rv-destination' ).parent(),
					ajax: {
						url: '/wp-json/pri-rest-extender/v1/search',
						delay: 750,
						cache: false,
						dataType: 'json',
						data: function ( params ) {
							params.type = 'rv';
							params.return_id_type = 'permalink';
							return params;
						}
					}
				});
/*
				const datepicker = new Datepicker( datefield[0], {
					buttonClass: 'btn',
					minDate: datefield.data( 'min-date' )
				} );
*/
			}

			// Select2 for MH
			if ( $( '.block--hubs-hero--widget--mh' ).length > 0 ) {
				const selector = $( '.block--hubs-hero--widget--mh' ).find( '#mh-destination' );

				selector.select2({
					allowClear: true,
					width: '100%',
					dropdownParent: $( '#mh-destination' ).parent(),
					ajax: {
						url: '/wp-json/pri-rest-extender/v1/search',
						delay: 750,
						cache: false,
						dataType: 'json',
						data: ( params ) => {
							params.type = 'mh';
							params.return_id_type = 'permalink';
							return params;
						}
					}
				});
			}
			
			// Submit the form
			$( '.block--hubs-hero--widget form' ).on( 'submit', ( ev ) => {
				const url = $( ev.currentTarget ).find( 'select' ).val();
				window.location = url;
				return false;
			} );
		}

		init();

	} )( window.jQuery );
}